import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography, ListItem, ListItemText } from '@mui/material'
import { ReactComponent as CalendarDay } from 'assets/CalendarDay.svg'
import { EVENT_INSTANCE_TYPES } from 'settings/constants/service'
import { formatNonWeeklyRecurrenceText, isDailyRecurrence } from 'utils/service'

const RecurrenceDetailsList = ({
  eventInstanceType,
  eventOccurrence,
  dayOfTheWeek,
  dayOfTheMonth,
  recurringServiceEvents = [],
  recurrenceInterval,
}) => {
  const isDayOfWeekEventInstance = eventInstanceType === EVENT_INSTANCE_TYPES.DAY_OF_WEEK

  const renderRecurrenceItem = (text, index = 0) => (
    <Stack key={index} direction="row" spacing={1} alignItems="center">
      <CalendarDay sx={{ color: 'text.secondary' }} width={20} height={20} />
      <Typography variant="subtitle2">{text}</Typography>
    </Stack>
  )

  // Don't show details for daily recurrence
  if (recurrenceInterval && isDailyRecurrence(recurrenceInterval)) {
    return null
  }

  let formattedText
  if (recurringServiceEvents && recurringServiceEvents.length > 0) {
    if (isDayOfWeekEventInstance) {
      // DAY_OF_WEEK type: extract arrays of dayOfTheWeek and eventOccurrence
      const eventOccurrenceArray = recurringServiceEvents.map(event => event.eventOccurrence)
      const dayOfTheWeekArray = recurringServiceEvents.map(event => event.dayOfTheWeek)
      formattedText = formatNonWeeklyRecurrenceText(eventInstanceType, eventOccurrenceArray, dayOfTheWeekArray, dayOfTheMonth)
    } else if (eventInstanceType === EVENT_INSTANCE_TYPES.SPECIFIC_DATE) {
      // SPECIFIC_DATE type: extract array of dayOfTheMonth
      const dayOfTheMonthArray = recurringServiceEvents.map(event => event.dayOfTheMonth)
      formattedText = formatNonWeeklyRecurrenceText(eventInstanceType, eventOccurrence, dayOfTheWeek, dayOfTheMonthArray)
    }
  } else {
    // Fall back to original individual values
    formattedText = formatNonWeeklyRecurrenceText(eventInstanceType, eventOccurrence, dayOfTheWeek, dayOfTheMonth)
  }

  if (!formattedText) return null

  // Split the formatted text by commas and render each as a separate list item
  const items = formattedText.split(', ')

  return items.map((item, index) => (
    <ListItem key={index} sx={{ px: 0, py: 0.5 }}>
      <ListItemText primary={renderRecurrenceItem(item.trim(), index)} sx={{ m: 0 }} />
    </ListItem>
  ))
}

RecurrenceDetailsList.propTypes = {
  eventInstanceType: PropTypes.string,
  eventOccurrence: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  dayOfTheWeek: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  dayOfTheMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  recurringServiceEvents: PropTypes.array,
  recurrenceInterval: PropTypes.string,
}

export default RecurrenceDetailsList
